import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
// import config from '@/config';
// import qs from 'qs'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: { title: '首页',requireAuth: false },
    component:()=>import('../views/home/Home'),
  },
  {
    path: '/join',
    name: 'join',
    meta: { title: '加入联盟',requireAuth: false },
    component:()=>import('../views/home/Join'),
  },
  {
    path: '/check-ticket',
    name: 'CheckTicket',
    meta: { title: '扫码验票',requireAuth: false },
    component:()=>import('../views/home/CheckTicket'),
  },
  {
    path: '/product-detail/:product_id',
    name: 'ProductDetail',
    meta: { title: '产品详情',requireAuth: false },
    component:()=>import('../views/product/ProductDetail'),
  },
  {
    path: '/product-detail-sale/:product_id/:sales_uid',  //产品购买详情页带上产品id和渠道id
    name: 'ProductDetailSale',
    meta: { title: '产品购买',requireAuth: false },
    component:()=>import('../views/product/ProductDetailSale'),
  },
  {
    path: '/giveaway-take/:pid/',
    name: 'GiveawayTake',
    meta: { title: '领取赠品',requireAuth: false },
    component:()=>import('../views/order/GiveawayTake'),
  },
  {
    path: '/create-order/',
    name: 'CreateOrder',
    meta: { title: '创建订单',requireAuth: false },
    component:()=>import('../views/order/CreateOrder'),
  },
  {
    path: '/order-success/:product_id/:sales_uid/:order_id/',
    name: 'OrderSuccess',
    meta: { title: '订单成功',requireAuth: false },
    component:()=>import('../views/order/OrderSuccess'),
  },
  {
    path: '/my-order-client/',
    name: 'MyOrderClient',
    meta: { title: '我的订单',requireAuth: false },
    component:()=>import('../views/order/MyOrderClient'),
  },
  {
    path: '/my-order-agent/',
    name: 'MyOrderAgent',
    meta: { title: '代理订单',requireAuth: false },
    component:()=>import('../views/order/MyOrderAgent'),
  },
  {
    path: '/account/',
    name: 'Account',
    meta: { title: '个人中心',requireAuth: false },
    component:()=>import('../views/account/Account'),
  },
  {
    path: '/my-ticket/',
    name: 'MyTicket',
    meta: { title: '我的电子票',requireAuth: false },
    component:()=>import('../views/account/MyTicket'),
  },
  {
    path: '/my-coupons/',
    name: 'MyCoupons',
    meta: { title: '我的优惠券',requireAuth: false },
    component:()=>import('../views/account/MyCoupons'),
  },
  {
    path: '/my-rewards/',
    name: 'MyRewards',
    meta: { title: '草莓雨奖品',requireAuth: false },
    component:()=>import('../views/account/MyRewards'),
  },
  {
    path: '/cash-apply/',
    name: 'CashApply',
    meta: { title: '提现申请',requireAuth: false },
    component:()=>import('../views/account/CashApply'),
  },
  {
    path: '/order-detail/:order_id',
    name: 'OrderDetail',
    meta: { title: '订单详情',requireAuth: false },
    component:()=>import('../views/order/OrderDetail'),
  },
  {
    path: '/giveaway-order/:id/:token',
    name: 'GiveawayOrder',
    meta: { title: '订单详情',requireAuth: false },
    component:()=>import('../views/order/GiveawayOrder'),
  },
  {
    path: '/order-express-detail/',
    name: 'OrderExpressDetail',
    meta: { title: '物流详情',requireAuth: false },
    component:()=>import('../views/order/OrderExpressDetail'),
  },
  {
    path: '/product-detail-group/:product_id/:rule_id/:group_id',
    name: 'ProductDetailGroup',
    meta: { title: '拼团',requireAuth: false },
    component:()=>import('../views/product/ProductDetailGroup'),
  },
  {
    path: '/draw-coupon/:id/:token',
    name: 'DrawCoupon',
    meta: { title: '优惠券',requireAuth: false },
    component:()=>import('../views/home/DrawCoupon'),
  },
  {
    path: '/create-order-batch/',
    name: 'CreateOrderBatch',
    meta: { title: '优惠购',requireAuth: false },
    component:()=>import('../views/order/CreateOrderBatch'),
  },
  {
    path: '/rain-index/',
    name: 'RainIndex',
    meta: { title: '草莓雨',requireAuth: false },
    component:()=>import('../views/farm/rain/RainIndex'),
  },
  {
    path: '/rain-game/',
    name: 'RainGame',
    meta: { title: '草莓雨',requireAuth: false },
    component:()=>import('../views/farm/rain/RainGame'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// const get_wx_auth_url = ()=>{
//   let redirect_uri=encodeURIComponent('https://maytown.hhland.com/api/index.php/api_weixin/weixin_auth_response');//debug mode
//   // let redirect_uri = encodeURIComponent(window.location.href);
//   let app_id=config.weixin.appid;
//   let state='';
//   return 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
//           'appid=' +app_id+
//           '&redirect_uri=' +redirect_uri+
//           '&response_type=code&scope=snsapi_userinfo&' +
//           'state=' +state+
//           '#wechat_redirect';
// };

router.beforeEach((to,from,next)=>{
  if(to.meta.requireAuth){
    let login_user = store.getters.getLoginUser;
    if(!login_user || !login_user.openid){
      next({
        path: '/join',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }else{
    next();
  }
  //
  // let auth_url=get_wx_auth_url();
  // let login_status=Number(store.getters.getLoginStatus);
  // console.log('登录状态',login_status);
  // if(login_status===0){
  //   //未登录，则发起微信授权登录
  //   console.log('未登录，发起微信授权。。。');
  //   store.commit('setLoginStatus',1);   //设置正在微信授权登录
  //   window.location.href = auth_url;    //触发微信授权
  // }else if(login_status===1){
  //   //正在微信授权
  //   console.log('------ 微信授权正在进行 ------');
  //   store.commit('setLoginStatus',3);
  //   //微信授权回调
  //   console.log('回调后进入的路径：',window.location.href);
  //   const parseUrl = qs.parse(window.location.href.split('?')[1]);
  //   console.log('parseUrl',parseUrl);
  //   console.log('返回的code',parseUrl.code);
  //   if(parseUrl.code){
  //     //得到了code说明用户同意了
  //     store.dispatch('WeixinLogin',{code:parseUrl.code}).then(res=>{
  //       console.log(res);
  //       if(res.status===0){
  //         //成功
  //         store.commit('setLoginStatus',2);
  //         next({path:'/home'});
  //       }else{
  //         //登录失败
  //         store.commit('setLoginStatus',3);
  //         next({path: '/join'});
  //       }
  //     })
  //   }else{
  //     //用户没同意，那就跳到登录页面去
  //     next({path: '/join'});
  //   }
  // }else{
  //   //已登录无需触发微信授权
  //   console.log('已登录');
  //   next();
  // }

});

export default router
